// ══════════════════════════════════════════════════════════════════════════════════════════════
//  LA FRANJA «ENTORNO DE PRUEBAS» (2-oct-2026, docs/ENTORNO-DE-PRUEBAS.md)
// ══════════════════════════════════════════════════════════════════════════════════════════════
//  En pruebas.biango.app se trabaja con datos inventados y no sale nada hacia fuera; en biango.app están las
//  clínicas de verdad. Las dos pantallas son idénticas, así que la de pruebas lleva un marco naranja alrededor de
//  toda la ventana y una etiqueta arriba, en todas las páginas (también el login y el portal), para no confundirse
//  nunca. El marco no se puede pulsar (pointer-events: none): no tapa ningún botón.
//
//  Solo aparece si las pantallas se compilaron con VITE_ENTORNO=pruebas, que lo pone routes/deploy.js en el
//  servidor de pruebas. En producción no existe esa variable: no se pinta nada y no se pide nada al servidor.
//  Lo mide backend/services/entorno-pruebas-franja.test.js.

import { marca, tDato } from './i18n.js'   // B-2259 · los textos, en el idioma de quien mira (utils/i18n)

export const ID_FRANJA = 'franja-entorno-pruebas'
export const TEXTO_FRANJA = marca('utils.franjaEntorno.entorno_de_pruebas_datos_inventados', 'ENTORNO DE PRUEBAS · datos inventados, no sale nada')

export function esEntornoDePruebas(valor) {
  return String(valor == null ? '' : valor).trim().toLowerCase() === 'pruebas'
}

// Lo que se compiló: Vite cambia `import.meta.env.VITE_ENTORNO` por su valor al compilar (sin la variable, undefined).
// Se lee AQUÍ y no en main.jsx porque las guardias que ejecutan main.jsx de verdad (marca-sigue-a-la-visita) no
// entienden `import.meta`; y dentro de un try porque fuera de Vite (Node) `import.meta.env` no existe.
export function entornoDeLaCompilacion() {
  try { return import.meta.env.VITE_ENTORNO } catch (_) { return undefined }
}

export function pintarFranjaDeLaCompilacion(doc) {
  return pintarFranjaEntorno(entornoDeLaCompilacion(), doc)
}

export function pintarFranjaEntorno(valor, doc = (typeof document !== 'undefined' ? document : null)) {
  if (!doc || !doc.body || !esEntornoDePruebas(valor)) return false
  if (doc.getElementById(ID_FRANJA)) return true
  const marco = doc.createElement('div')
  marco.id = ID_FRANJA
  marco.setAttribute('role', 'status')
  marco.setAttribute('aria-label', TEXTO_FRANJA)
  marco.style.cssText = 'position:fixed;inset:0;border:4px solid #d97706;pointer-events:none;z-index:2147483647'
  const etiqueta = doc.createElement('div')
  etiqueta.textContent = tDato(TEXTO_FRANJA)
  etiqueta.style.cssText = 'position:absolute;top:0;left:50%;transform:translateX(-50%);background:#d97706;color:#fff;'
    + 'font:600 12px/1.6 system-ui,sans-serif;letter-spacing:.04em;padding:1px 12px 3px;border-radius:0 0 6px 6px;'
    + 'white-space:nowrap;max-width:calc(100% - 16px);overflow:hidden;text-overflow:ellipsis'
  marco.appendChild(etiqueta)
  doc.body.appendChild(marco)
  if (!/^\[PRUEBAS\]/.test(doc.title || '')) doc.title = '[PRUEBAS] ' + (doc.title || 'Biango')
  return true
}
